<div class="btn-group">
  <button type="button"
          class="btn btn-primary signUpButton nowrap shadow"
          (click)="goToSignUpPage()"
          [ngClass]="{ 'nowrap small' : (screenType !== 'fullscreen')}"
  >
    Sign Up
  </button>
</div>
